import { useEffect, useState } from "react";
import { SIZE_OPTION_GROUP_ID } from "../../utils/Constant";
import SizeGuideModal from "./SizeGuide/SizeGuideModal";
import CustomSelect from "../Common/CustomSelect";
import { useSearchParams} from "react-router-dom";

function ProductOptionsDesktop({
  productId,
  isSizeGuideAvailable = false,
  showSizeMapping = false,
  productOptions,
  onOptionSelectedCb,
}) {

  /**
 * BOC 
 * task #149929 Darveys:- Ads feed - Product Page URL to be updated According to the size.
 * author Maanik Arya 
 * date 22-05-24
 * use_of_code :- We have added code to retrieve the currency and size_option_id from the query parameters.
 * The size_option_id is used to display the corresponding simple product with its specific size, ensuring the correct price for that size is shown on the product page.
 * This change was made to improve the accuracy of our Google feed. We send simple products with their prices and corresponding product links in the feed.
 * We are now updating the product links to include the currency and size_option_id parameters.
 * Initially, the displayed product price differed from the simple product price. Therefore, in the feed, we sent one price, but the price seen after following the link was different. This update resolves that discrepancy by ensuring consistency between the feed price and the price displayed upon visiting the product link.
 */
 const [searchParams] = useSearchParams();
 const prod_currency = searchParams.get('currency');
 const size_option_id = searchParams.get('size_option_id');
 /**
  * EOC
  */
  const [sizeOptions, setSizeOptions] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  // const [disableSize, setDisableSize] = useState(false);
  const [showOneSizeOption, setshowOneSizeOption] = useState("block");

  useEffect(() => {
    let sizeOptionsObj =
      productOptions?.find((e) => e.id === SIZE_OPTION_GROUP_ID) || {};
    setSizeOptions(sizeOptionsObj);
    if (sizeOptionsObj?.items && sizeOptionsObj?.items?.length === 1) {
      // setDisableSize(true);
      // if(!showSizeMapping) {
        setSelectedSize(sizeOptionsObj?.items[0]);
      // }
      //BOC - Task #143632 - One Size Products    
      //Authore : Meraj
      //Date : 17-10-2023
      //We have updatd the code because initially we have using the size id to check the one size product.
      //But now we are using the issizeguideavailable flag to check the one size product.for showing the size dropdown.
      // if(sizeOptionsObj?.items[0]?.id === '2181'){
      if(!isSizeGuideAvailable){  
        setshowOneSizeOption('none');
      }
    }
  }, [productOptions]);

  const handleSizeClick = (option) => {
    if(!showSizeMapping) { 
      let selectedsizeoption = sizeOptions?.items?.find((e) => e.id === option?.id);
      setSelectedSize(option);
      onOptionSelectedCb(sizeOptions?.id, option?.id, option?.value, selectedsizeoption?.special_price, selectedsizeoption?.discount_percentage);
    } else {
      let selectedsizeoption = sizeOptions?.items?.find((e) => e.id === option?.value);      
      onOptionSelectedCb(sizeOptions?.id, option?.value, option?.label, selectedsizeoption?.special_price, selectedsizeoption?.discount_percentage);
    }
  };

  if (!productOptions || productOptions.length < 1) return null;

  let productSizeOptions = [];
  sizeOptions?.items?.map((option, idx) => {
    let productSizeOption = { "value": option?.id, "label": option?.value,isDisabled: option?.available_for_order === '1' ? false:true }
    productSizeOptions = [...productSizeOptions, productSizeOption];
    return ("");
  });

  return (
    <>
      {sizeOptions && (
        <>
          <div style={{display : showOneSizeOption}} className="row">
            {!showSizeMapping ?
              (
                <>
                  <div className={`opt-${sizeOptions?.id} size mt-30`}>
                    <h6 className="text-black">
                      <span>{sizeOptions?.title}</span>
                    </h6>
                    {isSizeGuideAvailable && <SizeGuideModal productId={productId} />}
                  </div>

                  <ul
                    className="size-button mt-10"
                    id={`main-opt-${sizeOptions?.id}`}
                  >
                    {sizeOptions?.items?.map((option, idx) => {
                      return (
                        <li key={option?.id}>
                          <input
                            className="btn-check"
                            type="radio"
                            value={option?.id}
                            checked={selectedSize?.id === option?.id || false}
                            readOnly={true}
                            disabled={option?.available_for_order === "0"}
                          />
                          <label
                            className="cust-prod-radio btn btn-outline-success"
                            onClick={(e) => handleSizeClick(option)}
                          >
                            {option.value}
                          </label>
                        </li>
                      );
                    })}
                  </ul>
                </>
              )
              :
              (
                <>
                  <div className="col-md-8" style={{ display: "inline-block" }}>
                    {
                    /**
                     * BOC 
                     * task #149929 Darveys:- Ads feed - Product Page URL to be updated According to the size.
                     * author Maanik Arya 
                     * date 22-05-24
                     * use_of_code :- We have added code to select the default size on the product page according to the product size using the size_option_id .
                     * We are getting the size_option_id from the query parameter.
                     * The size_option_id is used to display the corresponding simple product with its specific size, ensuring the correct price for that size is shown on the product page.
                     * This change was made to improve the accuracy of our Google feed. We send simple products with their prices and corresponding product links in the feed.
                     * We are now updating the product links to include the currency and size_option_id parameters.
                     * Initially, the displayed product price differed from the simple product price. Therefore, in the feed, we sent one price, but the price seen after following the link was different. This update resolves that discrepancy by ensuring consistency between the feed price and the price displayed upon visiting the product link.
                     */
                    }
                    {(productSizeOptions.length > 0 && 
                      <CustomSelect
                        options={productSizeOptions}
                        defaultValue={size_option_id}
                        onChange={(e) => handleSizeClick(e)}
                        placeholder={`Select ${sizeOptions?.title}`}
                        isOptionDisabled={(option) => option.isDisabled}
                      />
                    )}
                    {
                      /**
                       * EOC
                       */
                    }

                  </div>
                  <div className="col-md-4" style={{ display: "inline-block" }}>
                    <div className={`opt-${sizeOptions?.id} size mt-30`}>
                      {isSizeGuideAvailable && <SizeGuideModal productId={productId} />}
                    </div>
                  </div>
                </>
              )
            }

          </div>
        </>
      )}
    </>
  );
}

export default ProductOptionsDesktop;
